import { render, staticRenderFns } from "./ActorMessageForm.vue?vue&type=template&id=e25e8e52"
import script from "./ActorMessageForm.vue?vue&type=script&lang=js"
export * from "./ActorMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports